import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../../account/angular/models/account.model";
import {ConsolidatedCommissionsService} from "../../services/consolidated-commissions-service.service";
import {CommissionStatusType} from "../../types/commission-status.type";
import * as _ from "lodash";
import {CommissionPaymentDetailsModel} from "../../models/commission-payment-details.model";
import {ConsolidatedCommissionModel} from "../../models/consolidated-commission.model";
import {CommissionModel} from "../../models/commission.model";
import {SupplyAccountType} from "../../../account/types/supply-account.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommissionRequestService} from "../../services/commission-requests.service";
import {CommissionsDialogService} from "../../services/commissions-dialogs-service.service";
import {CommissionsService} from "../../services/commissions-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {SortType} from "../../../commons/types/sort.type";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {AccountType} from "../../../account/types/account.type";
import {CommissionDeltaType} from "../../types/commission-delta.type";
import {ServiceStatus} from "../../../deliveries/constants/service-status.type";


export class CommissionsViewCtrl implements IController {
  account: AccountModel;
  agentId: string;

  supplyAccountIds: string[];
  agentIds: string[];
  accountIds: string[];
  from: string;
  to: string;
  statuses: any;
  isConsolidated: boolean;
  commissionDelta: CommissionDeltaType;
  serviceStatuses: ServiceStatus[];
  enableTotals?: boolean;
  selectedQuickFilterId: string;
  dateRangeTemplateType: DateRangeTemplateType;

  private commissionsRef: any;
  private canCreateConsolidate: boolean;
  private canUpdateConsolidate: boolean;
  public filtersConfig: any;
  public selectedTab: number;
  public selectedCommissionIds: string[];
  public selectedTotals: number;
  private totalResults = {
    services: undefined,
    sum: undefined
  };
  private currentView: string;
  public pageName: string;
  public actions: { canConsolidate, canPaySelected, canEditPrice, canAddManualCommission };
  public excludeMode: boolean;
  public supplyAccountTypes: typeof SupplyAccountType = SupplyAccountType;
  public configZoneId: string;
  public selectedSortName: string;
  public selectedSortType: SortType;
  public accountType: typeof AccountType = AccountType;
  public commissionDeltaType: typeof CommissionDeltaType = CommissionDeltaType;
  public commissionStatusType: typeof CommissionStatusType = CommissionStatusType;
  public selectedCommission: any;

  /* @ngInject */
  constructor(private $commission, private splitService: SplitService,
              private bringozLoaderService: BringozLoaderService, private $state, private IAMPermissions,
              private consolidatedCommissionsService: ConsolidatedCommissionsService,
              private viewFilterSettingsService: ViewFilterSettingsService,
              private $log, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private commissionRequestService: CommissionRequestService, private commissionsService: CommissionsService,
              private commonsAlertsService: CommonsAlertsService, private commissionsDialogService: CommissionsDialogService, private confirmDialogService: ConfirmDialogService, private $translate) {
    this.pageName = $state.current.name;
    this.commissionsRef = this.$commission();
    this.canCreateConsolidate = this.IAMPermissions.hasPermission('consolidateCommission.create');
    this.canUpdateConsolidate = this.IAMPermissions.hasPermission('consolidateCommission.update');
  }

  $onInit() {
    // this.viewTypes = ['Pending', 'Paid'];
    // this.currentView = 'Pending';
    this.configZoneId = this.splitService.getTimeZone();

    this.selectedTab = 0;
    this.filtersConfig = {
      queryString: undefined,
      customTemplates: this.dateRangeTimeFiltersService.getCommissionsCustomTemplates(),
      range: this.from && this.to ? {
        dateStart: this.from,
        dateEnd: this.to
      } : this.dateRangeTimeFiltersService.thisMonth(),
      statuses: this.statuses || [this.commissionStatusType.NotPaid],
      includeFilters: [
        SiteFiltersType.dateRangeTemplateType,
        SiteFiltersType.isConsolidated,
        SiteFiltersType.commissionDelta
      ],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.isConsolidated]: this.isConsolidated,
        [SiteFiltersType.commissionDelta]: this.commissionDelta,
        serviceStatuses: this.serviceStatuses || []
      },
      queryMap: {}
    };

    if (this.agentIds) {
      this.filtersConfig.includeFilters.push(SiteFiltersType.agentIds);
      this.filtersConfig.bringozFilters[SiteFiltersType.agentIds] = this.agentIds;
    }

    if (this.supplyAccountIds) {
      this.filtersConfig.includeFilters.push(SiteFiltersType.supplyAccountIds);
      this.filtersConfig.bringozFilters[SiteFiltersType.supplyAccountIds] = this.supplyAccountIds;
      this.filtersConfig.queryMap.supplierType = this.accountType.BusinessSupply;
    }

    if (this.accountIds) {
      this.filtersConfig.includeFilters.push(SiteFiltersType.accountIds);
      this.filtersConfig.bringozFilters[SiteFiltersType.accountIds] = this.accountIds;
    }

    this._getTotals();
    this._setSelectedCommissions([]);
  };

  onTabSelect(selectedTab) {
    this.selectedTab = selectedTab;
    this._setSelectedCommissions([]);
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filtersConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    if (!!filters.dateRangeTemplateType) {
      this.filtersConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this._setQueryParams();
    this._getTotals();
  }

  onOpenActions($mdMenu) {
    this._getCommissionsByIds(this.selectedCommissionIds)
      .then((commissions) => {
        this.actions = {
          canConsolidate: this.excludeMode ? false : !!_.get(commissions, 'length'),
          canPaySelected: !!this.excludeMode || !!_.get(commissions, 'length'),
          canEditPrice: !!this.excludeMode || !!_.get(commissions, 'length'),
          canAddManualCommission: this.excludeMode ? false : !!_.get(commissions, 'length')
        };

        if (!this.excludeMode) {
          _.forEach(commissions, (c) => {
            if (!!c.consolidatedCommissionReference?.id) {
              this.actions.canConsolidate = false;
              this.actions.canPaySelected = false;
            }
            if (c.status === this.commissionStatusType.Paid) {
              this.actions.canEditPrice = false;
              this.actions.canPaySelected = false;
              this.actions.canConsolidate = false;
            }
            if (c.status === this.commissionStatusType.Rejected) {
              this.actions.canEditPrice = false;
              this.actions.canPaySelected = false;
              this.actions.canConsolidate = false;
              this.actions.canAddManualCommission = false;
            }
          })
        }

        $mdMenu.open();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to Consolidate Commissions @onOpenActions', error);
        }
      })
  }

  onSortChange(sortName, sortType) {
    const isSameSortName = !!sortType && _.isEqual(this.selectedSortType, sortType);
    this.selectedSortType = isSameSortName ? (_.isEqual(this.selectedSortType, SortType.asc) ? SortType.desc : SortType.asc) : SortType.asc;
    this.selectedSortName = sortName;
  }

  onSelectedCommissionIdsChange(selectedIds, excludeMode) {
    this.excludeMode = excludeMode;
    this.selectedCommissionIds = selectedIds;
    this._setSelectedTotals(this.selectedCommissionIds);
  }

  onMarkAsPaidSelectedCommissions(selectedCommissionIds) {
    this.commissionsDialogService.payManually()
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {

        const queryParams = {}

        if (this.excludeMode) {
          _.set(queryParams, 'from', this.filtersConfig.range.dateStart);
          _.set(queryParams, 'to', this.filtersConfig.range.dateEnd);
          _.set(queryParams, 'accountIds', this.account?.id ? [this.account.id] : this.filtersConfig.bringozFilters.accountIds);
          _.set(queryParams, 'agentIds', this.agentId ? [this.agentId] : this.filtersConfig.bringozFilters.agentIds);
          _.set(queryParams, 'shipperAccountIds', this.filtersConfig.bringozFilters.supplyAccountIds);
          _.set(queryParams, 'isConsolidated', !_.isUndefined(this.filtersConfig.bringozFilters.isConsolidated) ? !this.filtersConfig.bringozFilters.isConsolidated : undefined);
          _.set(queryParams, this.commissionDeltaType.overcharge, this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.overcharge ? true : null);
          _.set(queryParams, this.commissionDeltaType.undercharge, this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.undercharge ? true : null);
          _.set(queryParams, this.commissionDeltaType.noGap, this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.noGap ? true : null);

          _.set(queryParams, 'excludeIds', selectedCommissionIds);
        } else {
          _.set(queryParams, 'commissionIds', selectedCommissionIds);
        }

        this._markAsPaid(commissionPaymentDetails, queryParams);
      })
  }


  onPaySelectedCommissions(selectedCommissionIds) {
    this.commissionsDialogService.pay()
      .then(p => {

        const payload = {
          paymentDetails: p.commissionPaymentDetails
        };

        _.set(payload, 'agentId', this.agentId);
        _.set(payload, 'accountId', this.account?.id);
        _.set(payload, 'consolidatedCommissionName', p.consolidatedCommissionName);

        if (this.excludeMode) {
          _.set(payload, 'from', this.filtersConfig.range.dateStart);
          _.set(payload, 'to', this.filtersConfig.range.dateEnd);
          _.set(payload, 'accountIds', this.account?.id ? [this.account.id] : this.filtersConfig.bringozFilters.accountIds);
          _.set(payload, 'agentIds', this.agentId ? [this.agentId] : this.filtersConfig.bringozFilters.agentIds);
          _.set(payload, 'shipperAccountIds', this.filtersConfig.bringozFilters.supplyAccountIds);
          _.set(payload, 'isConsolidated', !_.isUndefined(this.filtersConfig.bringozFilters.isConsolidated) ? !this.filtersConfig.bringozFilters.isConsolidated : undefined);
          _.set(payload, this.commissionDeltaType.overcharge, this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.overcharge ? true : null);
          _.set(payload, this.commissionDeltaType.undercharge, this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.undercharge ? true : null);
          _.set(payload, this.commissionDeltaType.noGap, this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.noGap ? true : null);
          _.set(payload, 'excludeIds', selectedCommissionIds);
        } else {
          _.set(payload, 'commissionIds', selectedCommissionIds);
        }

        this._pay(payload);

      })
  }

  onMarkAsPaidCommission(commission: CommissionModel) {
    this.commissionsDialogService.payManually(commission.serviceId, commission.paymentDetails, commission.commission)
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {
        const queryParams = {
          // accountId: this.account.id,
          // agentId: this.agentId,
          commissionIds: [commission.id]
        }
        this._markAsPaid(commissionPaymentDetails, queryParams);
      })
  }

  onPay(commission: CommissionModel) {
    this.commissionsDialogService.pay(commission.paymentDetails, undefined, commission.commission)
      .then(p => {
        const payload = {
          paymentDetails: p.commissionPaymentDetails
        };

        _.set(payload, 'agentId', this.agentId);
        _.set(payload, 'accountId', this.account.id);
        _.set(payload, 'consolidatedCommissionName', p.consolidatedCommissionName);
        _.set(payload, 'commissionIds', [commission.id]);

        this._pay(payload);
      })
  }

  onEditPrice(commission: CommissionModel) {
    this.commissionsDialogService.editPrice()
      .then((payload) => {
        this._editPrice(commission.id, payload.price, payload.comment);
      })
  }

  onRemoveCommissionFromConsolidate(commission, $event) {
    const text = 'Are you sure you want to remove this commission?';
    this.confirmDialogService.confirm('Remove Commission From Consolidated Commission', text, $event)
      .then(() => {
        this._removeCommissionsFromConsolidate(commission.consolidatedCommissionReference.id, [commission.id]);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }


  onConsolidateCommission(commission) {
    if (commission) {
      this.onConsolidateCommissions([commission.id])
    }
  }

  onConsolidateCommissions(ids) {
    if (this.excludeMode) {
      this.commissionsDialogService.consolidateCommissions(this.account.id)
        .then((payload) => {
          _.set(payload, 'from', this.filtersConfig.range.dateStart);
          _.set(payload, 'to', this.filtersConfig.range.dateEnd);
          _.set(payload, 'excludeIds', ids);
          _.set(payload, 'accountId', this.account.id);
          _.set(payload, 'agentId', this.agentId);
          if (!!payload.consolidatedId) {
            this._addCommissionsToConsolidatedCommission(payload);
          } else {
            this._createConsolidatedCommission(payload);
          }
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
    } else {
      this._getCommissionsByIds(ids)
        .then((commissions) => {
          return this.commissionsDialogService.consolidateCommissions(this.account.id, commissions);
        })
        .then((payload) => {
          _.set(payload, 'commissionIds', ids);
          _.set(payload, 'accountId', this.account.id);
          _.set(payload, 'agentId', this.agentId);
          if (!!payload.consolidatedId) {
            this._addCommissionsToConsolidatedCommission(payload);
          } else {
            this._createConsolidatedCommission(payload);
          }
        })
        .catch((error) => {
          if (error) {
            this.$log.error('Failed to Consolidate Commissions @onConsolidateCommissions', error);
          } else {
            this.$log.info('Dialog Closed');
          }
        })
    }
  }

  onClearSelected() {
    this.excludeMode = false;
    this._setSelectedCommissions([]);
  }

  // onQuery() {
  //   this.selectedCommissionIds = [];
  //   this.paymentIds = [];
  //   this.commissionPrice = 0;
  //   this.totalResults = {};
  //   this.textQuery = '';
  //
  //   if (_.isEqual(this.currentView, 'Pending')) {
  //
  //     this._getTotals();
  //     this._getCommissions()
  //       .then((commissions) => {
  //         this.commissions = commissions;
  //       })
  //   } else {
  //
  //     //Get Payments Total
  //     this.bringozLoaderService.on();
  //     this.$payment().$call(this.PaymentsAPI.actions.totals, this._getPaymentsQueryPayload())
  //       .then((totalResults) => {
  //         this.totalResults = totalResults
  //       })
  //       .catch((error) => {
  //         this.$log.error('Failed to get Payments Total', error)
  //       })
  //       .finally(() => {
  //         this.bringozLoaderService.off();
  //       });
  //
  //     //Get Payments
  //     this.bringozLoaderService.on();
  //     this.$payment().$getAll(this._getPaymentsQueryPayload())
  //       .then((paymentIds) => {
  //         this.paymentIds = paymentIds
  //       })
  //       .catch((error) => {
  //         this.$log.error('Failed to get payments from server', error)
  //       })
  //       .finally(() => {
  //         this.bringozLoaderService.off();
  //       });
  //   }
  // }

  onSelectViewType(type) {
    this.currentView = type;
  }

  onQueryChanged(query) {
    this.filtersConfig.queryString = query;
  }

  onTimeRangeSelected(range) {
    this.filtersConfig.range = range;

    if (this.selectedQuickFilterId && range.type !== this.filtersConfig.bringozFilters.dateRangeTemplateType) {
      this.selectedQuickFilterId = undefined;
    }

    this.filtersConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
    // this.viewFilterSettingsService.setDateRangeTemplateType(this.filtersConfig.bringozFilters.dateRangeTemplateType || undefined);

    this._getTotals();
    this._setQueryParams();
  }

  onStatusesChange(statuses: CommissionStatusType[]) {
    this.filtersConfig.statuses = statuses;
    this._getTotals();
    this._setQueryParams();
  }

  onServiceStatusesChange(values) {
    this.filtersConfig.bringozFilters.serviceStatuses = values;
    this._getTotals();
    this._setQueryParams();
  }

  onExportCommissions() {
    const payload = {
      fieldTranslationMap: this._getExportTablePayload(),
      metaDataMap: this._getExportMetadataMapPayload()
    };

    this.commissionsService.exportCommissions(this._getCommissionsQueryPayload(), payload)
      .then(() => {
        this.commonsAlertsService.exportToMailSuccess()
      })
      .catch((error) => {
        this.$log.error('Failed to export commissions', error)
      })
  }

  onDeleteCommission(commission) {
    const text = 'Are you sure you want to delete this commission?';
    this.confirmDialogService.confirm('Delete Commission', text)
      .then(() => {
        this._deleteCommission(commission.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onRejectCommission(commission: CommissionModel) {
    const text = 'Are you sure you want to reject this commission?';
    this.confirmDialogService.confirm('Reject Commission', text)
      .then(() => {
        const commissionCopy = angular.copy(commission);
        commissionCopy.status = this.commissionStatusType.Rejected;
        this._updateCommission(commissionCopy);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onRestoreCommission(commission: CommissionModel) {
    const text = 'Are you sure you want to restore this commission?';
    this.confirmDialogService.confirm('Restore Commission', text)
      .then(() => {
        const commissionCopy = angular.copy(commission);
        commissionCopy.status = this.commissionStatusType.NotPaid;
        this._updateCommission(commissionCopy);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onAddAFee($event) {
    this.commissionsDialogService.addFee($event)
      .then((payload) => {
        if (payload.feeType === 'Credit') {
          const attachments = payload.attachment ? [payload.attachment] : undefined;
          const descriptions = payload.description ? [payload.description] : undefined;
          this._addCredit(payload.amount, payload.isAssistant, payload.date, attachments, descriptions);
        }
        if (payload.feeType === 'Debt') {
          const attachments = payload.attachment ? [payload.attachment] : undefined;
          const descriptions = payload.description ? [payload.description] : undefined;
          this._addDebt(payload.amount, payload.isAssistant, payload.date, attachments, descriptions);
        }
      })
  }

  onBulkEditPrice($event) {
    this.commissionsDialogService.bulkEditPrice($event)
      .then((payload) => {
        this._bulkEditPrice(this.selectedCommissionIds, payload.price, payload.comment);
      })
  }

  onSelectCommission(commission) {
    this.selectedCommission = _.isEqual(commission.id, _.get(this.selectedCommission, 'id')) ?
      undefined : angular.copy(commission);
  }


  // ******************************
  //        Internal methods
  // ******************************

  private _getCommissionsByIds(ids) {
    return this.commissionsRef.$asyncValues(ids);
  }

  private _setSelectedCommissions(ids) {
    this.selectedCommissionIds = ids;
    this._setSelectedTotals(ids);
  }

  private _setSelectedTotals(ids) {
    if (!this.excludeMode && !ids.length) {
      this.selectedTotals = undefined;
    } else if (this.excludeMode && !ids.length) {
      this.selectedTotals = this.totalResults.sum
    } else if (ids.length) {
      this._getCommissionsByIds(ids)
        .then((commissions) => {
          if (this.excludeMode) {
            this.selectedTotals = this.totalResults.sum - _.sumBy(commissions, 'commission')
          } else {
            this.selectedTotals = _.sumBy(commissions, 'commission')
          }
        })
    }
  }

  private _markAsPaid(commissionPaymentDetails: CommissionPaymentDetailsModel, queryParams) {
    this.commissionsService.payManually(commissionPaymentDetails, queryParams)
      .then(() => {
        this._getTotals();
        this.onClearSelected();
      })
  }

  private _pay(payload) {
    this.commissionsService.pay(payload)
      .then(() => {
        this._getTotals();
        this.onClearSelected();
      })
  }

  private _editPrice(commissionId, price, comment) {
    this.commissionsService.editPrice(commissionId, price, comment)
      .then(() => {
        this._getTotals();
        this.onClearSelected();
      })
  }

  private _removeCommissionsFromConsolidate(consolidatedCommissionId, commissionsIds) {
    this.consolidatedCommissionsService.removeCommissions(consolidatedCommissionId, commissionsIds)
      .then((updatedConsolidatedCommission) => {

      })
  }

  private _addCredit(commission, isAssistant, date, attachments?, descriptions?) {
    const payload = {
      accountId: this.account.id,
      agentId: this.agentId,
      serviceId: undefined,
      consolidatedCommissionId: undefined,
      descriptions: descriptions,
      isAssistant: isAssistant,
      commissionDate: date,
      commissionMethodType: undefined,
      commission: commission,
      attachments: attachments
    }

    this.commissionsService.addCredit(payload)
      .then((commission) => {
        this._getTotals();
        this._refreshCommissions();
      })
  }

  private _addDebt(commission, isAssistant, date, attachments?, descriptions?) {
    const payload = {
      accountId: this.account.id,
      agentId: this.agentId,
      serviceId: undefined,
      consolidatedCommissionId: undefined,
      descriptions: descriptions,
      isAssistant: isAssistant,
      commissionDate: date,
      commissionMethodType: undefined,
      commission: commission,
      attachments: attachments
    }
    this.commissionsService.addDebt(payload)
      .then((commission) => {
        this._getTotals();
        this._refreshCommissions();
      })
  }

  private _createConsolidatedCommission(consolidatedCommissionPayload: ConsolidatedCommissionModel) {
    this.consolidatedCommissionsService.create(consolidatedCommissionPayload)
      .then(() => {
        this.onClearSelected();
      });
  }

  private _addCommissionsToConsolidatedCommission(payload) {
    this.consolidatedCommissionsService.addCommissions(payload.consolidatedId, payload)
      .then(() => {
        this.onClearSelected();
      });
  }

  private _bulkEditPrice(ids: string[], price: number, comment: string) {
    const query = {
      commissionIds: this.excludeMode ? undefined : ids,
      excludedIds: this.excludeMode ? ids : undefined,
      accountIds: this.account ? [this.account.id] : this.filtersConfig.bringozFilters.supplyAccountIds,
      shipperAccountIds: this.filtersConfig.bringozFilters.accountIds,
      agentIds: this.agentId ? [this.agentId] : this.filtersConfig.bringozFilters.agentIds,
      ignoreConsolidated: !_.isUndefined(this.filtersConfig.bringozFilters.isConsolidated) ? !this.filtersConfig.bringozFilters.isConsolidated : undefined,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd
    }
    this.commissionsService.bulkEditPrice(query, price, comment
    )
      .then(() => {
        this.onClearSelected();
      })
  }


// – from
//
// – to

  private _getTotals() {
    if (this.enableTotals) {
      this.bringozLoaderService.on();
      const payload = {
        ...this._getCommissionsQueryPayload(),
        accountId: this.account?.id,
        agentId: this.agentId,
      }
      this.commissionRequestService.getTotals(payload)
        .then((totalResults) => {
          this.totalResults = totalResults
        })
        .catch((error) => {
          this.$log.error('Failed to get Commissions Total', error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    }
  }

  private _deleteCommission(id: string) {
    this.commissionsService.deleteOne(id)
      .then(() => {
        this._refreshCommissions();
      })
  }

  private _updateCommission(commission: CommissionModel) {
    this.commissionsService.updateOne(commission)
      .then(() => {
        this._refreshCommissions();
      })
  }

  private _getCommissionsQueryPayload() {
    return {
      accountIds: this.account ? [this.account.id] : this.filtersConfig.bringozFilters.supplyAccountIds,
      agentIds: this.agentId ? [this.agentId] : this.filtersConfig.bringozFilters.agentIds,
      shipperAccountIds: this.filtersConfig.bringozFilters.accountIds,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      status: this.filtersConfig.statuses,
      ignoreConsolidated: !_.isUndefined(this.filtersConfig.bringozFilters.isConsolidated) ? !this.filtersConfig.bringozFilters.isConsolidated : undefined,
      overcharge: this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.overcharge ? true : null,
      undercharge: this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.undercharge ? true : null,
      noGap: this.filtersConfig.bringozFilters.commissionDelta === this.commissionDeltaType.noGap ? true : null,
      serviceStatus: this.filtersConfig.bringozFilters.serviceStatuses,
      zoneId: this.configZoneId
      // accountId: this.account?.id,
    }
  }

  private _setQueryParams() {
    this.$state.go('.', {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      statuses: this.filtersConfig.statuses,
      supplyAccountIds: this.filtersConfig.bringozFilters.supplyAccountIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      isConsolidated: this.filtersConfig.bringozFilters.isConsolidated,
      commissionDelta: this.filtersConfig.bringozFilters.commissionDelta,
      serviceStatuses: this.filtersConfig.bringozFilters.serviceStatuses,
    }, {
      notify: false,
      reload: false
    })
  }


  private _refreshCommissions() {
    this.filtersConfig = angular.copy(this.filtersConfig);
  }


  private _getPaymentsQueryPayload() {
    return {
      accountId: this.account.id,
      agentId: _.get(this.filtersConfig, 'agentId'),
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      desc: true
    }
  }

  private _getExportTablePayload() {
    return {
      id: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.serviceId'),
      status: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Status'),
      accountName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.accountName'),
      agentName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.agentName'),
      agentId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.agentId'),
      serviceId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.serviceId'),
      serviceExternalId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.serviceExternalId'),
      createdAt: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.createdAt'),
      carrierName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.carrierName'),
      pickupCity: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.pickupCity'),
      pickupStreet: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.pickupStreet'),
      dropoffCity: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.dropoffCity'),
      dropoffStreet: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.dropoffStreet'),
      numberOfPackages: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Packages'),
      packageName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.packageName'),
      packageBarcodes: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.packageBarcodes'),
      distance: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Distance'),
      consolidatedCommissionName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Consolidate'),
      accountCommissionType: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Type'),
      paymentDetails: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paymentAdditionalInfo'),
      carrierFee: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.CarrierFee'),
      contractPrice: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.ContractPrice'),
      commissionDelta: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.PriceDelta'),
      servicePrice: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.servicePrice'),
      shipperAccountName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.accountName'),
      commission: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.amount'),
      serviceType: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.ServiceType'),
      descriptions: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Description'),
      assistant: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Manual'),
      commissionMethodType: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Commission'),
      timeWindow: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.timeWindow'),
      attachments: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.Attachments')
    }
  }

  private _getExportMetadataMapPayload() {
    return {}
  }
}

angular
  .module('bringoz.admin.commissions')
  .component('commissionsView', {
    bindings: {
      account: '<?',
      agentId: '<',
      supplyAccountIds: '<',
      agentIds: '<',
      accountIds: '<?',
      from: '<?',
      to: '<?',
      statuses: '<?',
      isConsolidated: '<',
      commissionDelta: '<?',
      serviceStatuses: '<?',
      enableTotals: '<?',
      selectedQuickFilterId: '<?',
      dateRangeTemplateType: '<?'
    },
    template: require('./commissions-view.html').default,
    controller: CommissionsViewCtrl
  });
